module.exports = __webpack_public_path__ + "img/1440.2a7ceb99.jpg";